import React, { FC, memo } from 'react';
import FormikSearchInput from '@minecraft.formik-search-input';
import { FilterData } from '../../../shared/types';

type Props = FilterData & { testId?: string; className?: string };

const Search: FC<Props> = ({ name, label, testId = 'filter-basic-search', className }) => {
  return <FormikSearchInput name={name} placeholder={label} label={label} testId={testId} className={className} />;
};

export default memo(Search);
